const recentInteractionsLoaded = (payload) => (dispatch) => {
  dispatch({
    type: 'RECENT_INTERACTIONS_LOADED',
    payload,
  });
};

export default recentInteractionsLoaded;
